import IntakeConfig from '../../interfaces/IntakeConfig.interface';

const planConfigCA: NonNullable<IntakeConfig['plan']>['countries'][string] = {
  label: 'Social AI',
  description: 'Content created weekly and automatically posted to your socials.\nIncludes posting to Facebook and Instagram.',
  periods: [
    {
      id: 'social-ai-local-monthly-cad',
      label: 'Monthly',
      price: 9900,
      unit: 'monthly',
      addons: [
        {
          id: 'platforms',
          label: 'Additional Platforms',
          type: 'multiselect',
          options: [
            {
              id: 'linkedin-*-cad',
              itemPriceId: 'linkedin-monthly-cad',
              label: 'LinkedIn',
              price: 2900,
              unit: 'monthly',
            },
          ],
        },
        {
          id: 'setupAssistance',
          label: 'Setup Assistance',
          description: 'Don\'t have a Facebook or Instagram account yet? Let us set them up for you.',
          type: 'multiselect',
          options: [
            {
              id: 'facebook-setup-cad',
              label: 'Basic Facebook Page Creation',
              price: 7500,
              unit: 'one-time',
            },
            {
              id: 'instagram-setup-cad',
              label: 'Basic Instagram Account Creation',
              price: 7500,
              unit: 'one-time',
            },
            {
              id: 'linkedin-setup-cad',
              label: 'Basic LinkedIn Page Creation',
              price: 7500,
              unit: 'one-time',
            },
          ],
        },
        {
          id: 'video',
          label: 'Video',
          type: 'multiselect',
          options: [
            {
              id: 'short-form-video-*-cad',
              itemPriceId: 'short-form-video-monthly-cad',
              label: 'Short-Form Videos',
              price: 9900,
              unit: 'monthly',
            },
          ],
        },
      ],
    },
    {
      id: 'social-ai-local-annual-cad',
      label: 'Annual',
      price: 99000,
      unit: 'annually',
      addons: [
        {
          id: 'platforms',
          label: 'Additional Platforms',
          type: 'multiselect',
          options: [
            {
              id: 'linkedin-*-cad',
              itemPriceId: 'linkedin-annual-cad',
              label: 'LinkedIn',
              price: 29000,
              unit: 'annually',
            },
          ],
        },
        {
          id: 'setupAssistance',
          label: 'Setup Assistance',
          description: 'Don\'t have a Facebook or Instagram account yet? Let us set them up for you.',
          type: 'multiselect',
          options: [
            {
              id: 'facebook-setup-cad',
              label: 'Basic Facebook Page Creation',
              price: 7500,
              unit: 'one-time',
            },
            {
              id: 'instagram-setup-cad',
              label: 'Basic Instagram Account Creation',
              price: 7500,
              unit: 'one-time',
            },
            {
              id: 'linkedin-setup-cad',
              label: 'Basic LinkedIn Page Creation',
              price: 7500,
              unit: 'one-time',
            },
          ],
        },
        {
          id: 'video',
          label: 'Video',
          type: 'multiselect',
          options: [
            {
              id: 'short-form-video-*-cad',
              itemPriceId: 'short-form-video-annual-cad',
              label: 'Short-Form Videos',
              price: 99000,
              unit: 'annually',
            },
          ],
        },
      ],
    },
  ],
};

export default planConfigCA;
